export const twoFAStatus = (type, callFrom) => {
    if (type == 'enabled' && callFrom == 'status') {
        return "ENABLED"
    } else if (type == 'disabled' && callFrom == 'status') {
        return "DISABLED"
    } else if (type == 'enabled' && callFrom == 'button') {
        return "DISABLED"
    } else if (type == 'disabled' && callFrom == 'button') {
        return "ENABLE"
    } else {
        return ""
    }
}